module.exports = __webpack_public_path__ + "img/clock.9b1478c2.svg";